<div class="custom-select-container">

	<mat-select #selectElement
				class="form-control filter-options custom-select"
				[ngClass]="extraClass"
				[class.has-clear-icon]="clearable && hasValue && !(disabled ?? false)"
				[disableOptionCentering]="true"
				[panelClass]="'lc-multiselect-panel'"
				(selectionChange)="oncSelectionChange($event)"
				(openedChange)="openedChange($event)"
				[(ngModel)]="value"
				[matTooltip]="(( options ?? []) | getValueOnCondition:'id':'name':value:value | async) ?? ''"
				multiple
				[disabled]="disabled?? false">
		<ng-container *ngIf="searchable">
			<div class="search-container">
				<div class="input-group">
					<input
						#searchInput
						class="form-control"
						[(ngModel)]="searchValue"
						(ngModelChange)="onSearchValueChange($event)"
						placeholder="Search any Id"/>
					<button type="button"
							class="btn btn-outline-secondary bi bi-x-lg btn-picker"
							[disabled]="!searchValue"
							(click)="onSearchValueChange('')"
					>
					</button>
				</div>
			</div>
		</ng-container>

		<div #optionsScroll class="options-scroll">
			<mat-option *ngFor="let option of filterOptions; trackBy: trackByOptionId"
						[value]="option.id">{{ option.name }}
			</mat-option>

			<div *ngIf="filterOptions?.length === 0"
				 class="empty-message w-100 text-center fw-bold mb-2">
				No result found
			</div>
		</div>

		<div *ngIf="clearable" class="clear-footer">
			<button type="button"
					class="btn btn-outline-secondary w-100 clear-btn"
					[disabled]="!hasValue"
					(click)="clear($event)">
				Clear
			</button>
		</div>

	</mat-select>

	<i *ngIf="clearable && hasValue && !(disabled ?? false)"
	   class="bi bi-trash-fill clear-trigger-icon"
	   role="button"
	   aria-label="Clear"
	   (click)="clear($event)">
	</i>

</div>
